import Vue from "vue";
import Vuex from "vuex"

Vue.use(Vuex)

// 创建vuex实例
export default new Vuex.Store({
    state: {
        selectedMenuItem: null
      },
      mutations: {
        setSelectedMenuItem(state, item) {
          state.selectedMenuItem = item;
        }
      },
      actions: {
        selectMenuItem({ commit }, item) {
          commit('setSelectedMenuItem', item);
        }
      },
      getters: {
        getSelectedMenuItem: state => state.selectedMenuItem
      },

})